import type { CustomIconProps } from '../CustomIcon';

export function Durable(props: CustomIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="3285.58 50.96 360 360" {...props}>
      <path d="M3465.57,53.96c-97.75,0-176.99,79.24-176.99,176.99s79.24,176.99,176.99,176.99,176.99-79.24,176.99-176.99-79.24-176.99-176.99-176.99M3465.57,59.37c94.61,0,171.58,76.97,171.58,171.58s-76.97,171.58-171.58,171.58-171.58-76.97-171.58-171.58,76.97-171.58,171.58-171.58" />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3465.63,137.1l50.45,57.97M3415.07,195.07l50.56-57.97M3427.37,137.1h108.03l44.8,57.97-114.62,155.47M3577.56,195.07h-171.27M3535.4,137.1l-69.83,213.44M3503.78,137.1h-108.03l-44.8,57.97,114.62,155.47M3353.59,195.07h171.27M3395.75,137.1l69.83,213.44"
      />
    </svg>
  );
}
